import { render, staticRenderFns } from "./AverageCompletionTimes.vue?vue&type=template&id=436fe1c0&"
import script from "./AverageCompletionTimes.vue?vue&type=script&lang=js&"
export * from "./AverageCompletionTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports